import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var transformCentralizedOrgData = function transformCentralizedOrgData(data) {
  if (!data) {
    return undefined;
  }
  if (data.__typename === 'CentralizedOrganizationTenantNode') {
    // this is created in this way so we can support multiple branding versions in the future
    // maybe in the future we will just support 3 levels of palette colors or maybe the palette colors can have more levels
    // also the backend is storing the palette colors in a versioned way, so we need to support that too
    var brandingVersion = data.branding.palette_colors.__typename === 'CentralizedOrganizationTenantPaletteColorsV1Node' ? 'v1' : 'v1';
    return {
      id: Number(data.id),
      slug: data.slug,
      name: data.name,
      /**
       * This data is consumed by the OrganizationBrandingProvider component from the @crehana/layouts package to apply the branding styles to the page
       */
      branding: {
        paletteColors: _defineProperty({}, brandingVersion, {
          darkest: data.branding.palette_colors.darkest,
          dark: data.branding.palette_colors.dark,
          base: data.branding.palette_colors.base,
          light: data.branding.palette_colors.light,
          lightest: data.branding.palette_colors.lightest
        }),
        imageLogo: {
          id: data.branding.image_logo.id,
          absoluteUrl: data.branding.image_logo.absolute_url
        },
        imageFavicon: {
          id: data.branding.image_favicon.id,
          absoluteUrl: data.branding.image_favicon.absolute_url
        },
        imageIsotype: {
          id: data.branding.image_isotype.id,
          absoluteUrl: data.branding.image_isotype.absolute_url
        },
        imagePageLoginHero: {
          id: data.branding.image_page_login_hero.id,
          absoluteUrl: data.branding.image_page_login_hero.absolute_url
        }
      }
    };
  }
  return undefined;
};